import React, { useEffect, useState } from "react";
import "./AdminHeaderContent.css";
// import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { getData, putData } from "../../../Services/Api";
import { useForm } from "react-hook-form";
import { GetUserDetails } from "../../../Helpers/Utility";
import { toast } from "react-toastify";

export default function AdminHeaderContent() {
  const [headerContent, setHeaderContent] = useState({
    id: 1,
    title: "",
    subtitle: "",
    description: "",
  });
  const [userToken, setUserToken] = useState("");
  // const [error, setError] = useState("");

  useEffect(() => {
    const getUserData = async () => {
      const userDetails = GetUserDetails();
      if (userDetails?.token) {
        setUserToken(userDetails.token);
        const headers = {
          Authorization: `Bearer ${userDetails.token}`,
        };
        const getDataResponse = await getData(
          "header-content-details",
          headers
        );
        if (getDataResponse.data) {
          setHeaderContent(getDataResponse.data?.data[0]);
        }
      }
    };

    getUserData();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  useEffect(() => {
    setValue("title", headerContent.title);
    setValue("subtitle", headerContent.subtitle);
    setValue("description", headerContent.description);
  }, [headerContent, setValue]);

  const onSubmit = async (data) => {
    const sendData = {
      id: headerContent.id,
      title: data.title || "",
      subtitle: data.subtitle || "",
      description: data.description || "",
    };

    const headers = {
      Authorization: `Bearer ${userToken}`,
    };

    const getDataResponse = await putData(
      "update-header-content",
      sendData,
      headers
    );
    if (getDataResponse.success) {
      toast.success("Header content update");
    } else {
      // setError(getDataResponse?.message);
      toast.error(getDataResponse?.message);
    }
  };

  return (
    <section className="AdminSubscription px-3">
      <div className="AdminSubscriptionTable">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-block w-100 headingAdmin py-3">
            <h2 className="">Header Content</h2>
          </div>
        </div>
        <div className="AdminSubscriptionTableSection bg-white p-2 px-0 rounded-4">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="align-items-center px-4 py-3">
              <h4 className="">Content</h4>
              <Col md={12} className="py-3 pb-0">
                <Form.Group className="mb-3" controlId="title">
                  <Form.Label className="fw-medium">Title</Form.Label>
                  <Form.Control
                    type="title"
                    className="customFormTextAdmin rounded-5"
                    placeholder="Enter Title"
                    {...register("title", { required: "Title is required" })}
                  />
                  {errors.title && (
                    <span className="text-danger">{errors.title.message}</span>
                  )}
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="mb-3" controlId="subtitle">
                  <Form.Label className="fw-medium">Subtitle</Form.Label>
                  <Form.Control
                    type="text"
                    className="customFormTextAdmin rounded-5"
                    placeholder="Enter Sub-Title"
                    {...register("subtitle", {
                      required: "Sub-Title is required",
                    })}
                  />
                  {errors.subtitle && (
                    <span className="text-danger">
                      {errors.subtitle.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="mb-3" controlId="description">
                  <Form.Label className="fw-medium">Description</Form.Label>
                  <Form.Control
                    className="customFormTextAdmin rounded-2"
                    as="textarea"
                    rows={3}
                    placeholder="Enter Description"
                    {...register("description", {
                      required: "Description is required",
                    })}
                  />
                  {errors.description && (
                    <span className="text-danger">
                      {errors.description.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end ms-auto py-3">
              {/* <button
                type="button"
                className="respoNavBtn btn btn-default bg-transparent border-1 border-black rounded-5 pt-2 pb-2 px-4 text-black mx-2"
              >
                Cancel
              </button> */}
              <button
                type="submit"
                className="respoNavBtn btn btn-default startedBtn border-1 border-success rounded-5 pt-2 pb-2 px-4 text-white"
              >
                Update
              </button>
            </div>
          </Form>
        </div>
      </div>
    </section>
  );
}
